import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { message } from "../../../actions";
import { createBlocks, patchBlocks } from "../actions/Blocks";

import Icon from "../../../components/Icon";
import Form from "../../../components/Form";
import { patchQuestionnaires } from "../actions/Questionnaires";

const mapStateToProps = ( state ) =>
{
	return {
		questionnaires: state.questionnaires,
		blocksByQuestionnaireId: state.blocksByQuestionnaireId
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		patchQuestionnaires: ( formData ) =>
		{
			dispatch( patchQuestionnaires( formData ) );
		},
		patchBlocks: ( a_formData, a_block_id, a_questionnaireId, a_params ) =>
		{
			dispatch( patchBlocks( a_formData, a_block_id, a_questionnaireId, a_params ) );
		},
		postBlocks: ( block, questionnaire_id ) =>
		{
			dispatch( createBlocks( block, questionnaire_id ) );
		},
		message: ( a_message, a_type, a_timeout ) =>
		{
			dispatch( message( a_message, a_type, a_timeout ) );
		}
	};
};

/**
 * Blockkomponente der GUI
 */
class Block extends React.Component
{
	constructor( props )
	{
		super( props );
		
		this.state = {
			saveDisabled: true
		};
		
		this.handleNewBlock = this.handleNewBlock.bind( this );
		this.handleEditBlock = this.handleEditBlock.bind( this );
		this.handleEditForm = this.handleEditForm.bind( this );
		
	} // function constructor(...)
	
	componentDidUpdate( prevProps, prevState, snapshot )
	{
		const { node } = { ...this.props };
		
		if ( prevProps.node && node && prevProps.node.id !== node.id )
		{
			this.setState(
				{
					saveDisabled: true
				}
			);
		}
		
	} // function componentDidUpdate(...)
	
	/**
	 * Einen neuen Block speichern
	 *
	 * @param {Object} a_event Buttonevent
	 * @param {Object} a_block Inhalte des neuen Blocks
	 */
	handleNewBlock( a_event, a_block )
	{
		const { blocksByQuestionnaireId, questionnaires, lastSelectedNode, questionnaireId } = { ...this.props };
		
		// Pflichtfelder prüfen
		if ( a_block.title.length === 0 )
		{
			this.props.message( "Bitte den Blocktitel eingeben.", "warning", 5000 );
			return a_event.preventDefault();
		}
		
		const lastBlockId = Object.keys( blocksByQuestionnaireId[questionnaireId] )
			.sort( ( block1, block2 ) => blocksByQuestionnaireId[questionnaireId][block1].sort_id - blocksByQuestionnaireId[questionnaireId][block2].sort_id ).pop();
		const last_block = blocksByQuestionnaireId[questionnaireId][lastBlockId];
		const block = { ...a_block, sort_id: last_block !== undefined ? Number.parseInt( last_block.sort_id, 10 ) + 1 : 1 };
		
		if ( lastSelectedNode )
		{
			const lastSelectedBlock = blocksByQuestionnaireId[questionnaireId][lastSelectedNode.block_id ? lastSelectedNode.block_id : lastSelectedNode.id];
			block["new_sort_id"] = Number.parseInt( lastSelectedBlock.sort_id, 10 ) + 1;
		}
		
		this.props.postBlocks( block, questionnaireId );
		
		// Fragebogen wieder deaktivieren
		if ( questionnaires[questionnaireId].active === "1" )
		{
			this.props.patchQuestionnaires( { ...questionnaires[questionnaireId], active: "0" } );
		}
		
		this.setState( { saveDisabled: false } );
		
		a_event.preventDefault();
		
	} // function handleNewBlock(...)
	
	/**
	 * Einen Block ändern
	 *
	 * @param {Object} a_event Buttonevent
	 * @param {Object} a_block Inhalte des geänderten Blocks
	 */
	handleEditBlock( a_event, a_block )
	{
		const { blocksByQuestionnaireId, questionnaireId } = { ...this.props };
		
		const currentBlock = blocksByQuestionnaireId[questionnaireId][a_block.id];
		
		// Wenn Änderungen vorliegen dann ausführen
		if ( currentBlock.title !== a_block.title || currentBlock.description !== a_block.description )
		{
			const formData = {};
			formData["title"] = a_block.title;
			formData["description"] = a_block.description;
			this.props.patchBlocks( formData, a_block.id, this.props.questionnaireId );
		}
		else
		{
			// Wenn keine Änderungen vorliegen
			this.setState( { saveDisabled: true } );
			this.props.message( "Es liegen keine Änderungen vor." );
		}
		
		a_event.preventDefault();
		
	} // function handleEditBlock(...)
	
	/**
	 * Event: Wenn Änderungen vorgenommen werden, dann den Änderungsspeichernbutton aktivieren
	 */
	handleEditForm()
	{
		this.setState( { saveDisabled: false } );
		
	} // function handleEditForm(...)
	
	render()
	{
		const { className = null, node, blocksByQuestionnaireId, questionnaireId } = { ...this.props };
		const block = node && node.id && questionnaireId && blocksByQuestionnaireId ? blocksByQuestionnaireId[questionnaireId][node.id] : null;
		
		return <div className={className}>
			<h5>{block ? `Block ${node.sortId}` : "Neuer Block"}</h5>
			{
				block
					? <Form
						id={"form-edit-block"}
						submitValue={[ <Icon key={`form-edit-block-icon`} iconName={"edit"}/>, <span key={`form-edit-block-text`}>Block ändern</span> ]}
						onSubmit={( event, formData ) => this.handleEditBlock( event, formData )}
						fields={[
							{
								name: "title",
								title: "Titel",
								type: "text",
								required: true,
								className: "padding-right"
							},
							{
								name: "description",
								title: "Beschreibung",
								type: "textarea",
								className: "padding-right"
							}
						]}
						disabled={this.state.saveDisabled}
						onChange={this.handleEditForm}
						values={block}
					/>
					: <Form
						id={"form-new-block"}
						submitValue={[ <Icon key={`form-new-block-icon`} iconName={"add"}/>, <span key={`form-new-block-text`}>Block erstellen</span> ]}
						onSubmit={( event, formData ) => this.handleNewBlock( event, formData )}
						fields={[
							{
								name: "title",
								title: "Titel",
								type: "text",
								required: true,
								className: "padding-right"
							},
							{
								name: "description",
								title: "Beschreibung",
								type: "textarea",
								className: "padding-right"
							}
						]}
					/>
			}
		</div>;
		
	} // function render()
	
} // class

Block.propTypes = {
	className: PropTypes.string,
	node: PropTypes.object,
	isNew: PropTypes.bool,
	questionnaireId: PropTypes.oneOfType( [ PropTypes.number, PropTypes.string ] ),
	lastSelectedNode: PropTypes.object
};

Block = connect(
	mapStateToProps,
	mapDispatchToProps
)( Block );

export default Block;